import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function StockFactors({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/BondsDef");
    };

    const goPrev = () => {
        navigate("/StockDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Factors that Affect Stocks
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Stock prices are affected by many factors, the most powerful of which is 
                </div>
                <div className="text-[#000000] text-3xl">
                    supply and demand.  Less powerful ones are inflation (increases stock value), 
                </div>
                <div className="text-[#000000] text-3xl">
                    deflation (decreases stock value), the economic strength of the market, trends, and 
                </div>
                <div className="text-[#000000] text-3xl">
                    liquidity (how easily the stock can be traded).  The news and the market’s 
                </div>
                <div className="text-[#000000] text-3xl">
                    perception of a corporation can also affect stock prices.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    As you can see, many things affect stock prices, which is why stock is 
                </div>
                <div className="text-[#000000] text-3xl">
                    considered high risk.  However, if you understand the flow of supply and 
                </div>
                <div className="text-[#000000] text-3xl">
                    demand, you will be able to turn a profit.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}